let api="https://newwms.szestp.com:8082/"//默认 npm run build打包会用这个地址

if (process.env.NODE_ENV === 'development') {   //npm run build
    api="https://cswms.szestp.com:8088/"//开发
} else if (process.env.VUE_APP_CURRENTMODE === 'test') {    //npm run build-test
    api="https://cswms.szestp.com:8088/"//测试
    // api="http://39.108.37.175:8099/"//测试
} else if (process.env.VUE_APP_CURRENTMODE === 'prod') {    //npm run build-prod
    api=" https://newwms.szestp.com:8082/"//正式
}

export default api